import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "es-modal-header" }
const _hoisted_2 = { class: "es-modal-header-txt" }
const _hoisted_3 = { class: "row-top w-full pbottom-10" }
const _hoisted_4 = { class: "col w-full" }
const _hoisted_5 = { class: "row w-full mtop-10" }
const _hoisted_6 = { class: "col-0-8 colend mright-04" }
const _hoisted_7 = { class: "main-m font-m" }
const _hoisted_8 = { class: "row w-full mtop-10" }
const _hoisted_9 = { class: "col-0-8 colend mright-04" }
const _hoisted_10 = { class: "main-m font-m" }
const _hoisted_11 = { class: "row w-full mtop-10" }
const _hoisted_12 = { class: "col-0-8 colend mright-04" }
const _hoisted_13 = { class: "main-m font-m" }
const _hoisted_14 = { class: "row w-full mtop-10" }
const _hoisted_15 = { class: "col-0-8 colend mright-04" }
const _hoisted_16 = { class: "main-m font-m" }
const _hoisted_17 = { class: "row w-full mtop-10" }
const _hoisted_18 = { class: "col-0-8 colend mright-04" }
const _hoisted_19 = { class: "main-m font-m" }
const _hoisted_20 = {
  key: 0,
  class: "row w-full mtop-10"
}
const _hoisted_21 = { class: "col-0-8 colend mright-04" }
const _hoisted_22 = { class: "main-m font-m" }
const _hoisted_23 = {
  key: 1,
  class: "row w-full mtop-10"
}
const _hoisted_24 = { class: "col-0-8 colend mright-04" }
const _hoisted_25 = { class: "main-m font-m" }
const _hoisted_26 = { class: "col w-full" }
const _hoisted_27 = { class: "row w-full mtop-10" }
const _hoisted_28 = { class: "col-0-8 colend mright-04" }
const _hoisted_29 = { class: "main-m font-m" }
const _hoisted_30 = { class: "row w-full mtop-10" }
const _hoisted_31 = { class: "col-0-8 colend mright-04" }
const _hoisted_32 = { class: "main-m font-m" }
const _hoisted_33 = { class: "row w-full mtop-10" }
const _hoisted_34 = { class: "col-0-8 colend mright-04" }
const _hoisted_35 = { class: "main-m font-m" }
const _hoisted_36 = {
  key: 0,
  class: "row w-full mtop-10"
}
const _hoisted_37 = { class: "col-0-8 colend mright-04" }
const _hoisted_38 = { class: "main-m font-m" }
const _hoisted_39 = {
  key: 1,
  class: "row w-full mtop-10"
}
const _hoisted_40 = { class: "col-0-8 colend mright-04" }
const _hoisted_41 = { class: "main-m font-m" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "es-modal-header-border" }
const _hoisted_44 = { class: "es-modal-header-txt" }
const _hoisted_45 = { class: "row-top w-full" }
const _hoisted_46 = { class: "row-space-between w-full permission-block mtop-10" }
const _hoisted_47 = { class: "colend mright-04" }
const _hoisted_48 = { class: "main-m font-m" }
const _hoisted_49 = { class: "rowcenter w-full mtop-10 gap-08" }

import { ref, onMounted, watch, computed } from "vue";
import { CreateUpdatePersonRequest } from '@/apiGenerate/medserver';
import { useI18n } from "vue-i18n";
import { format } from "date-fns";
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import { ItemSelect, ItemSelectPhone, prefixPhone, SctLanguageSelect } from "@/models/share.model";
import { DateFormat } from "@/models/share.model";
import EsSelectCountry from '@/components/esSelectCountry.vue';
import { LANGUAGE_LIST, PHONE_PREFIX_LIST } from "@/functions/geo";
import { isHealthProOrHealthProStudent, isHealthPro } from "@/utils/role-utils";
import ToggleSwitch from "primevue/toggleswitch";


export default /*@__PURE__*/_defineComponent({
  __name: 'esPersonForm',
  props: {
    personRoleTypes: {},
    specificRoleType: {},
    cancelCloseModal: { type: Boolean },
    initForm: { type: Boolean },
    currentMedicalPerson: {}
  },
  emits: ['confirm-form', 'update-init-form'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();

const emit = __emit;

const createUpdatePersonRequest = ref<CreateUpdatePersonRequest>({
    personId: undefined,
    firstname: undefined,
    lastname: undefined,
    role: undefined,
    birthdate: undefined,
    luHealthProNumber: undefined,
    nlpPref: undefined,
    ssnLt: undefined,
    favoritePhone: {
        phoneNumber: undefined,
        phonePrefix: prefixPhone.LU
    },
    favoriteEmail: undefined,
    favoriteLanguage: undefined,
    modulePortalPatient: undefined,
    bic: undefined,
    iban: undefined
});

const confirmDisabled = ref<boolean>(false);
const sctLanguages = ref<ItemSelect[]>([]);
const countries = ref<ItemSelect[]>([]);
const phoneCountries = ref<ItemSelect[]>([]);
const isSsnInputDisable = ref<boolean>(false);
const isFinancialDataVisible = ref<boolean>(false);

const currentLanguageSelect = computed<ItemSelect | undefined>(() => {
  if (!props.currentMedicalPerson) return undefined;

  return countries.value.find(
    (item) => item.id === props.currentMedicalPerson.favoriteLanguage
  );
});

const currentLanguageNlpSelect = computed<ItemSelect | undefined>(() => {
  if (!props.currentMedicalPerson) return undefined;

  return sctLanguages.value.find(
    (item) => item.label === props.currentMedicalPerson.nlpPref
  );
});


const initForm = () => {
    if(props.currentMedicalPerson){
        isSsnInputDisable.value = true;
        isFinancialDataVisible.value = false;

        createUpdatePersonRequest.value = {
            personId: props.currentMedicalPerson.personId,
            firstname: props.currentMedicalPerson.firstname,
            lastname: props.currentMedicalPerson.lastname,
            role: props.currentMedicalPerson.role ? props.personRoleTypes.find((personRoleType) => personRoleType === props.currentMedicalPerson.role) : undefined,
            birthdate: props.currentMedicalPerson.birthdate,
            luHealthProNumber: props.currentMedicalPerson.luHealthProNumber,
            nlpPref: props.currentMedicalPerson.nlpPref,
            ssnLt: props.currentMedicalPerson.ssnLt,
            favoritePhone: {
                phoneNumber: props.currentMedicalPerson.favoritePhone?.phoneNumber ?? "",
                phonePrefix: props.currentMedicalPerson.favoritePhone?.phonePrefix || prefixPhone.LU,
            },
            modulePortalPatient: props.currentMedicalPerson.modulePortalPatient,
            favoriteEmail: props.currentMedicalPerson.favoriteEmail,
            favoriteLanguage: props.currentMedicalPerson.favoriteLanguage,
            bic: props.currentMedicalPerson.bic,
            iban: props.currentMedicalPerson.iban
        };
    }else {
        isSsnInputDisable.value = false;
        isFinancialDataVisible.value = true;

        createUpdatePersonRequest.value = {
            personId: undefined,
            firstname: undefined,
            lastname: undefined,
            role: props.specificRoleType ? props.personRoleTypes.find((personRoleType) => personRoleType === props.specificRoleType) : undefined,
            birthdate: undefined,
            luHealthProNumber: undefined,
            nlpPref: undefined,
            ssnLt: undefined,
            favoritePhone: {
                phoneNumber: undefined,
                phonePrefix: prefixPhone.LU
            },
            modulePortalPatient: undefined,
            favoriteEmail: undefined,
            bic: undefined,
            iban: undefined
        };
    }
}

const confirmForm = () => {
    if (!createUpdatePersonRequest.value.favoritePhone) {
        createUpdatePersonRequest.value.favoritePhone = { phoneNumber: undefined, phonePrefix: prefixPhone.LU };
    }
    emit('confirm-form', createUpdatePersonRequest.value);
}

const cancelForm = () => {
    initForm();
    if (props.cancelCloseModal) {
        emit('confirm-form');
    }
}

const updateDate = (newDate: string) => {
    createUpdatePersonRequest.value.birthdate = format(new Date(newDate), DateFormat.ISO_SMALL);
}

const sctLanguageToItemSelect = (lang: any): ItemSelect => ({
  id: lang.id ,
  label: lang.label,
});

const getSctLanguage = () => {
  sctLanguages.value = Object.values(SctLanguageSelect).map(sctLanguageToItemSelect);
};

const countryToItemSelect = (language: {languageIso: string; term: string}): ItemSelect => {
  return {
    id: language.languageIso,
    label: language.term,
  }
}

const getCountries = () => {
  countries.value = LANGUAGE_LIST.map((language: {languageIso: string; term: string}) => {
    return countryToItemSelect(language);
  });
}

const phoneCountryToItemSelect = (phone: {prefix: string, isoCode: string; term: string}): ItemSelectPhone => {
  return {
    id: phone.isoCode,
    label: `${phone.term}`, 
    prefix: `+${phone.prefix}` 
  }
}

const getPhoneCountries = () => {
  phoneCountries.value = PHONE_PREFIX_LIST.map((phone: {prefix: string, isoCode: string; term: string}) => {
    return phoneCountryToItemSelect(phone);
  });
}

const updateSSN = () => {
    isSsnInputDisable.value = false;
}

watch(
  () => props.initForm,
  () => {
    if (props.initForm) {
        initForm();
        emit('update-init-form', false);
    }
  },
  { deep: true }
);

onMounted(() => {
    getSctLanguage();
    getCountries();
    getPhoneCountries();
    initForm();
})


return (_ctx: any,_cache: any) => {
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_es_button = _resolveComponent("es-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(t)('admin.institute.person.header.generalInfo')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(_unref(t)('admin.institute.person.form.firstname')), 1),
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
            ])
          ]),
          _createVNode(_unref(InputText), {
            type: "text",
            size: "small",
            modelValue: createUpdatePersonRequest.value.firstname,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createUpdatePersonRequest.value.firstname) = $event)),
            class: "w-full"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createTextVNode(_toDisplayString(_unref(t)('admin.institute.person.form.lastname')), 1),
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
            ])
          ]),
          _createVNode(_unref(InputText), {
            type: "text",
            size: "small",
            modelValue: createUpdatePersonRequest.value.lastname,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((createUpdatePersonRequest.value.lastname) = $event)),
            class: "w-full"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, [
              _createTextVNode(_toDisplayString(_unref(t)('admin.institute.person.form.birthdate')), 1),
              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
            ])
          ]),
          _createVNode(_component_esInputDateTime, {
            dateTimeValue: createUpdatePersonRequest.value.birthdate ? new Date(createUpdatePersonRequest.value.birthdate) : null,
            dateFormat: _unref(DateFormat).DATEPICKER,
            withTime: false,
            range: false,
            onUpdateDateTime: _cache[2] || (_cache[2] = ($event: any) => (updateDate($event))),
            size: "small",
            class: "w-full"
          }, null, 8, ["dateTimeValue", "dateFormat"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, [
              _createTextVNode(_toDisplayString(_unref(t)('admin.institute.person.form.role')), 1),
              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
            ])
          ]),
          _createVNode(_unref(Select), {
            modelValue: createUpdatePersonRequest.value.role,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createUpdatePersonRequest.value.role) = $event)),
            options: _ctx.personRoleTypes,
            disabled: _ctx.specificRoleType !== undefined,
            size: "small",
            class: "w-full"
          }, _createSlots({
            option: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_unref(t)(`common.personRole.${slotProps.option.toUpperCase()}`)), 1)
            ]),
            _: 2
          }, [
            (createUpdatePersonRequest.value.role)
              ? {
                  name: "value",
                  fn: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_unref(t)(`common.personRole.${slotProps.value.toUpperCase()}`)), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "options", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, [
              _createTextVNode(_toDisplayString(_unref(t)('admin.institute.person.form.ssnLt')), 1),
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
            ])
          ]),
          _createVNode(_unref(InputText), {
            type: "text",
            size: "small",
            modelValue: createUpdatePersonRequest.value.ssnLt,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((createUpdatePersonRequest.value.ssnLt) = $event)),
            class: "w-full",
            disabled: isSsnInputDisable.value
          }, null, 8, ["modelValue", "disabled"]),
          (_ctx.currentMedicalPerson !== null && isSsnInputDisable.value)
            ? (_openBlock(), _createBlock(_component_es_button_icon, {
                key: 0,
                class: "mright-05 pad-m",
                icon: "pencil_fill",
                folder: "shareIcons",
                styles: "img-grey",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (updateSSN()))
              }))
            : _createCommentVNode("", true)
        ]),
        (isFinancialDataVisible.value && _unref(isHealthPro)(createUpdatePersonRequest.value.role))
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, [
                  _createTextVNode(_toDisplayString(_unref(t)('admin.institute.person.form.iban')), 1),
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                ])
              ]),
              _createVNode(_unref(InputText), {
                type: "text",
                size: "small",
                modelValue: createUpdatePersonRequest.value.iban,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((createUpdatePersonRequest.value.iban) = $event)),
                class: "w-full"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (isFinancialDataVisible.value && _unref(isHealthPro)(createUpdatePersonRequest.value.role))
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, [
                  _createTextVNode(_toDisplayString(_unref(t)('admin.institute.person.form.bic')), 1),
                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                ])
              ]),
              _createVNode(_unref(InputText), {
                type: "text",
                size: "small",
                modelValue: createUpdatePersonRequest.value.bic,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((createUpdatePersonRequest.value.bic) = $event)),
                class: "w-full"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('admin.institute.person.form.favoritePhone')), 1)
          ]),
          _createVNode(EsSelectCountry, {
            modelValue: createUpdatePersonRequest.value.favoritePhone.phonePrefix,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((createUpdatePersonRequest.value.favoritePhone.phonePrefix) = $event)),
            countries: phoneCountries.value,
            "show-prefix": true,
            default: true,
            onChangeSelect: _cache[9] || (_cache[9] = currentCountry => createUpdatePersonRequest.value.favoritePhone.phonePrefix = currentCountry),
            class: "w-60"
          }, null, 8, ["modelValue", "countries"]),
          _createVNode(_unref(InputText), {
            type: "text",
            size: "small",
            modelValue: createUpdatePersonRequest.value.favoritePhone.phoneNumber,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((createUpdatePersonRequest.value.favoritePhone.phoneNumber) = $event)),
            class: "w-full mleft-40"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('admin.institute.person.form.favoriteEmail')), 1)
          ]),
          _createVNode(_unref(InputText), {
            type: "text",
            size: "small",
            modelValue: createUpdatePersonRequest.value.favoriteEmail,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((createUpdatePersonRequest.value.favoriteEmail) = $event)),
            class: "w-full"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("span", _hoisted_35, [
              _createTextVNode(_toDisplayString(_unref(t)('admin.institute.person.form.favoriteLanguage')), 1),
              _cache[27] || (_cache[27] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
            ])
          ]),
          _createVNode(EsSelectCountry, {
            modelValue: createUpdatePersonRequest.value.favoriteLanguage,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((createUpdatePersonRequest.value.favoriteLanguage) = $event)),
            "selected-data": currentLanguageSelect.value,
            countries: countries.value,
            default: false,
            onChangeSelect: _cache[13] || (_cache[13] = currentCountry => createUpdatePersonRequest.value.favoriteLanguage = currentCountry)
          }, null, 8, ["modelValue", "selected-data", "countries"])
        ]),
        (_unref(isHealthProOrHealthProStudent)(createUpdatePersonRequest.value.role))
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("span", _hoisted_38, [
                  _createTextVNode(_toDisplayString(_unref(t)('admin.institute.person.form.misaNumber')), 1),
                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                ])
              ]),
              _createVNode(_unref(InputText), {
                type: "text",
                size: "small",
                modelValue: createUpdatePersonRequest.value.luHealthProNumber,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((createUpdatePersonRequest.value.luHealthProNumber) = $event)),
                class: "w-full"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_unref(isHealthProOrHealthProStudent)(createUpdatePersonRequest.value.role))
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, [
                  _createTextVNode(_toDisplayString(_unref(t)('admin.institute.person.form.nlpPref')), 1),
                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                ])
              ]),
              _createVNode(EsSelectCountry, {
                modelValue: createUpdatePersonRequest.value.nlpPref,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((createUpdatePersonRequest.value.nlpPref) = $event)),
                countries: sctLanguages.value,
                "selected-data": currentLanguageNlpSelect.value,
                "show-prefix": false,
                default: false,
                onChangeSelect: _cache[16] || (_cache[16] = currentCountry => createUpdatePersonRequest.value.nlpPref = Object.values(_unref(SctLanguageSelect)).find(item => item.id === currentCountry)?.label)
              }, null, 8, ["modelValue", "countries", "selected-data"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(isHealthProOrHealthProStudent)(createUpdatePersonRequest.value.role))
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("h4", _hoisted_44, _toDisplayString(_unref(t)('admin.institute.person.header.options')), 1)
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(t)('admin.institute.person.form.portalPatientModule')), 1)
              ]),
              _createVNode(_unref(ToggleSwitch), {
                modelValue: createUpdatePersonRequest.value.modulePortalPatient,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((createUpdatePersonRequest.value.modulePortalPatient) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_49, [
      _createVNode(_component_es_button, {
        label: _unref(t)('action.cancel'),
        onClick: _cache[18] || (_cache[18] = ($event: any) => (cancelForm())),
        "is-primary": false
      }, null, 8, ["label"]),
      _createVNode(_component_es_button, {
        disabled: confirmDisabled.value,
        label: _unref(t)('action.save'),
        onClick: _cache[19] || (_cache[19] = ($event: any) => (confirmForm())),
        "is-primary": true
      }, null, 8, ["disabled", "label"])
    ])
  ], 64))
}
}

})